// antd theme settings
// https://github.com/ant-design/ant-design/blob/master/components/style/themes/default.less

module.exports = {
  '@card-head-background': '#fff',
  '@card-background': '#000',
}